<template>
    <button class="btn" :class="'btn-'+type+' btn-'+asize" @click="$emit('click',$event)" @mouseover="hidden=false" @mouseout="hidden=true" :title="simplehint">
      <div v-if="(glyph||glyphfa)&&(titlepos=='bottom')">
        <span class="glyphicon" :class="'glyphicon-'+glyph"></span>
        <font-awesome-icon v-if="glyphfa" :icon="['fas',glyphfa ]"></font-awesome-icon>
      </div>
      <span class="innerbbtn">
        <span v-if="glyph&&(titlepos!='bottom')" class="glyphicon" :class="'glyphicon-'+glyph"></span>
        <font-awesome-icon v-if="glyphfa&&(titlepos!='bottom')" :icon="['fas',glyphfa ]"></font-awesome-icon>
        <transition name="slide" v-if="hint"><span v-show="!hidden" v-html="' '+hint"></span></transition>
        <span v-if="title" v-html="' '+title"></span>
        <span v-if="badge" class="pull-right badge">{{badge}}</span>
      </span>
    </button>
</template>
<script>
export default {
        props: ['type','hint','glyph','title','simplehint','size','glyphfa','titlepos','badge'],
        data(){
          return {
            hidden:true,
            asize:(this.size==null)?'sm':this.size
          }
        }
    }
</script>

<style>
.slide-enter-active
{
  animation: slide-in 1s;
}

.slide-leave-active
{
  animation: slide-in 1s reverse;
}

@keyframes slide-in {
  0% {
    transform: scale(0,1);
  }
  50% {
    transform: scale(0.5,1);
  }
  100% {
    transform: scale(1,1);
  }
}

.btn-sm{
  padding-top: 5px;
  padding-bottom: 5px;
}

span.innerbbtn{
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 5px;
}


</style>